module.exports = __webpack_public_path__ + "static/media/feature-4.b09c824f.jpg";